import React from 'react'
import "../../styles/s_machine.css"
import Prodcard1 from '../../components/prodcards/Prodcard'
import img18 from '../../img/shrinkC/18.jpeg'

export const ShrinkC = () => {
    const des= {
        img18: ['Voltage- AC 220/50','Power-4','Speed- 700 ~100','Dimension- 1945*795*1080','Weight -80','Packing Dimnsion - 500*375*250' ]
    
      }
  return (
    <div className='prdmain'>
    <div className='head2'>
      <h1>Shrink Chamber</h1>
    </div>
    <div className='items1'>
    <Prodcard1
        imageSrc={img18}
        model={"VP 5540"}
        title="Shrink Chamber"
        altText="img of websit"
        description={des.img18}
      />
      
    </div>


  </div>
  )
}
